export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/product_photography.afc1253.svg";